module.exports = __webpack_public_path__ + "img/杭州微引百度地图2.71c9cb0d.png";